<template>
  <div>
    <v-card>
      <!-- <vue-dropzone 
        ref="myVueDropzone" 
        id="dropzone"
        :options="dropzoneOptions"
      ></vue-dropzone> -->
      <v-form>

        <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-success="uploadSuccess" @vdropzone-removed-file="removeFile"></vue-dropzone>
        <v-textarea v-model="form.name" label="ชื่อ" ></v-textarea>
        <v-textarea v-model="form.amount" label="จำนวณ" ></v-textarea>

      </v-form>
      <v-btn @click="submit">submit</v-btn>
    </v-card>
    {{dropzoneOptions.headers}} <br>
    {{httpHeaders}}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vue2Dropzone from 'vue2-dropzone'
import swal from 'sweetalert2'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      form: {
        name: null,
        amount: null
      },
      /*dropzoneOptions: {
          url: '/api/attachmentDocuments',
          thumbnailWidth: 150,
          maxFiles: 1,
          maxFilesize: 0.5,
          // addRemoveLinks: true,
          autoProcessQueue: false,
          headers: { "Authorization": [ 'Bearer', this.$store.getters.token].join(' ') }
      }*/
      dropzoneOptions: {
        url: '/api/attachmentDocuments',
        headers: { 'Authorization': ['Bearer', this.$store.getters.token].join(' ') },
        autoProcessQueue: false,
        addRemoveLinks: true,
        createImageThumbnails: true,
        acceptedFiles: 'image/*,application/pdf,.pdf,.PDF',
        maxFiles: 1
      },
    }
  },
  mounted () {
    this.dropzoneOptions.url = this.uri
  },
  computed: {
    ...mapGetters([
      'token'
    ]),
    uri () {
      // return `/api/attachmentDocuments`
      return `https://httpbin.org/post`
    },
    httpHeaders () {
      return {'Authorization': [ 'Bearer', this.$store.getters.token].join(' ')}
    }
  },
  methods: {
    fileAdded (file) {
      console.log("fileAdded", file)
    },
    uploadSuccess (file, response) {
      console.log("uploadSuccess", response)
    },
    removeFile (file, error, xhr) {
      console.log("removeFile", file)
    },
    submit () {
      this.$refs.myVueDropzone.processQueue()
      this.axios.post(`api/attachmentDocuments`, this.form)
      .then((response) => {
          
            console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/test.vue